import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export type THBaseProps = {
    $color?: COLORS,
}

/**
 * Desktop: 56/66
 * Tablet: 40/50
 * Mobile: 32/42
 */
export const PromoTextWithStyleHeading1 = styled.p<THBaseProps>`
    width: auto;
    margin: 0;
    color: ${({ $color = 'inherit' }) => $color};

    ${FONTS.H2}
    line-height: 42px;

    @media (min-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H1};
        line-height: 50px;
    }

    @media (min-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H0};
        line-height: 66px;
    }
`;

/**
 * Desktop: 40/50
 * Laptop: 32/42
 * Tablet+Mobile: 24/32
 */
export const PromoTextWithStyleHeading2 = styled.p<THBaseProps>`
    width: auto;
    margin: 0;
    color: ${({ $color = 'inherit' }) => $color};

    ${FONTS.H3};

    @media (min-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H2};
        line-height: 42px;
    }

    @media (min-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H1};
        line-height: 50px;
    }
`;
